import { Component, OnInit } from '@angular/core';
import { Gallery, GalleryItem, ImageItem } from '@ngx-gallery/core';
import { Lightbox } from '@ngx-gallery/lightbox';
import { GaleriaService } from './galeria.service';

@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.css']
})
export class GaleriaComponent implements OnInit {

  items: GalleryItem[];
  items2: GalleryItem[];
  items3: GalleryItem[];
  items4: GalleryItem[];



  imageData = [
    {
      srcUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1442.JPG',
      previewUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1442.JPG'
    },
    {
      srcUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1470.JPG',
      previewUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1470.JPG'
    },
    {
      srcUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1500.JPG',
      previewUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1500.JPG'
    },
    {
      srcUrl: 'assets/imagens/imagens_galeria/posseCMCTI/noticia_8052_1.png',
      previewUrl: 'assets/imagens/imagens_galeria/posseCMCTI/noticia_8052_1.png'
    },
    {
      srcUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1490.JPG',
      previewUrl: 'assets/imagens/imagens_galeria/posseCMCTI/IMG_1490.JPG'
    }
  ];

  itemGaleria2 = [
    {
      srcUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/DSC_5730.JPG',
      previewUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/DSC_5730.JPG'
    },
    {
      srcUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/noticia_8115_1.png',
      previewUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/noticia_8115_1.png'
    },
    {
      srcUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/DSC_5729.JPG',
      previewUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/DSC_5729.JPG'
    },
  ];

  itemGaleria3 = [
    {
      srcUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/noticia_8534_1.png',
      previewUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/noticia_8534_1.png',
    },
    {
      srcUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/SITE%2002.jpg',
      previewUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/SITE%2002.jpg'
    },
    {
      srcUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/SITE%2003.jpg',
      previewUrl: 'http://www.parnamirim.rn.gov.br/img/noticias/SITE%2003.jpg',
    },
  ]




  constructor(private galeriaService: GaleriaService, public gallery: Gallery, public lightbox: Lightbox){
    // this.getGaleria1();
    // this.getGaleria2();
    // this.getGaleria3();
  }

  ngOnInit() {
    this.items = this.imageData.map(item => {
      return new ImageItem(item.srcUrl, item.previewUrl);
    });
    this.items2 = this.itemGaleria2.map(item => {
      return new ImageItem(item.srcUrl, item.previewUrl);
    });
    this.items3 = this.itemGaleria3.map(item => {
      return new ImageItem(item.srcUrl, item.previewUrl);
    });

    this.gallery.ref('lightbox').load(this.items);
    this.gallery.ref('lightbox2').load(this.items2);
    this.gallery.ref('lightbox3').load(this.items3);

  }

}



// WEBPACK FOOTER //
// ./src/app/portal-cmcti/galeria/galeria.component.ts